import { BaseModel } from './baseModel';

export class FormFieldChoice extends BaseModel {
  public formField: number;
  public value: number;

  // Content-free existence flag, populated when the endpoint doesn't load the full `answers` list.
  public answered?: boolean;

  constructor(
    public description: string,
    public order: number
  ) { super(); }

  public hasAnswers(): boolean {
    return !!this.answered;
  }
}
